import React from 'react'
import styled from 'styled-components'

const Margin = styled.div`
    margin: 0 auto;
    width: 90%;
    max-width: ${props => (props.maxWidth ? props.maxWidth : '1100px')};
`

export default ({ children, marginLeft, marginRight, className,
    maxWidth, backgroundColor, ...props }) =>
(
    <div css={{ backgroundColor: backgroundColor }} >
        <Margin {...props} className={className} marginLeft={marginLeft} marginRight={marginRight} maxWidth={maxWidth} backgroundColor={backgroundColor}>
            {children}
        </Margin>
    </div>
)